import React from "react";
import { Link } from "react-router-dom";

const Button = ({ className, children, onClick, to, type = "button", disabled }) => {
    const hasBGColorClass = /(^|\s)bg-(?!opacity)/.test(className);
    const bgClass = hasBGColorClass ? "" : " bg-dark bg-opacity-15 bg-opacity-25-hover";
    const classes = `btn${className ? " " + className : ""}${bgClass} fw-medium border-0`;
    const commonProps = {
        className: classes,
        disabled: disabled // Add disabled attribute based on the 'disabled' prop
    };

    return (
        <>
            {to ?
                <Link {...commonProps} to={to}>{children}</Link>:
                <button {...commonProps} onClick={onClick} type={type}>{children}</button>
            }
        </>
    );
}

export default Button;
